module.exports = __webpack_public_path__ + "static/media/act-3.6861be37.mp3";